/**
 * @author: lv.chen
 * @date: 2025/12/15
 * @desc: ProductChangedRankStore组件
 */
import React from 'react';
import classnames from 'classnames';
import GameImage from '@home/components/GameImage';
import EllipsisHover from '@home/components/EllipsisHover';
import { getCountryFlag } from '@home/_config/countries';
import { getRankElement, getDodClassName, renderChangeTag } from '../../utils';

import IMG_APPSTORE from '@intelligence/assets/imgs/casualDailyReports/icon-appstore.png';
import IMG_GOOGLE from '@intelligence/assets/imgs/casualDailyReports/icon-google.png';

const storeIconMap: IRecord<string> = {
  'appstore top free': IMG_APPSTORE,
  'appstore top paid': IMG_APPSTORE,
  'appstore top grossing': IMG_APPSTORE,
  'googleplay top free': IMG_GOOGLE,
  'googleplay top paid': IMG_GOOGLE,
  'googleplay top grossing': IMG_GOOGLE,
};

const storeNameMap: IRecord<string> = {
  'appstore top free': '免费榜',
  'appstore top paid': '付费榜',
  'appstore top grossing': '收入榜',
  'googleplay top free': '免费榜',
  'googleplay top paid': '付费榜',
  'googleplay top grossing': '收入榜',
};

interface IProductChangedRankStoreProps extends IBaseProps {
  ranks?: IStoreRankChangeItem[] | null;
  onGoToGameDetails?: (game?: any) => void;
}

const ProductChangedRankStore: React.FC<IProductChangedRankStoreProps> = (props) => {
  const { style, className, ranks, onGoToGameDetails } = props;

  return (
    <div
      style={style}
      className={classnames(
        'dbi-casual-daily-reports-product-changed-rank-store dbi-update-rank-card dbi-update-rank-card--shop',
        className,
      )}
    >
      <div className="dbi-update-rank-card-content">
        <div className="dbi-update-rank-card-hd">
          <div className="dbi-update-rank-card-title">
            <span>商店排行异动榜</span>
          </div>
          <div className="dbi-update-rank-card-th">榜单</div>
          <div className="dbi-update-rank-card-th">
            国家数/变化量
            <span className="dbi-icon-rank-down"></span>
          </div>
        </div>
        <div className="dbi-update-rank-list">
          {ranks?.map((rank, rankIndex) => {
            const rankSource = rank?.source || '';
            const storeIcon = storeIconMap[rankSource] || '';
            const storeName = storeNameMap[rankSource] || '';
            const rankMarketDod = rank?.delta_market_count;
            const tag = rank?.tag;
            const tagDesc = rank?.tag_desc;

            return (
              <div
                key={rankIndex}
                className="dbi-update-rank-item dbi-update-rank-item--store-rank dbi-cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  onGoToGameDetails?.(rank);
                }}
              >
                <div className="dbi-rank-card">
                  <div className="dbi-rank-card-index">{getRankElement(rankIndex)}</div>
                  <div className="dbi-rank-card-info">
                    <div className="dbi-rank-card-info-avatar">
                      <GameImage entityType="mobile" src={rank?.cover} />
                    </div>
                    <div className="dbi-rank-card-info-text">
                      <div className="dbi-rank-card-info-title">
                        <EllipsisHover text={rank?.entity_name || ''} />
                      </div>
                      <div className="dbi-rank-card-info-desc">
                        <img
                          className="dbi-rank-card-info-desc-img"
                          src={getCountryFlag(rank?.publisher_country_abbre)}
                          alt="rank"
                        />
                        <EllipsisHover text={rank?.publisher} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dbi-update-rank-card-td dbi-update-rank-card-td--platform">
                  <div className="dbi-update-rank-card-platform">
                    <img src={storeIcon} alt="google" />
                    <span>{storeName}</span>
                  </div>
                </div>
                <div className="dbi-update-rank-card-td">
                  <div className="dbi-rank-card-info-trend">
                    <div className="dbi-rank-info-trend-percent">
                      {renderChangeTag(tag, tagDesc)}
                      <span className="s1">{rank?.cur_top10_market_count}</span>
                      {typeof rankMarketDod === 'number' && (
                        <span className={classnames('s2', getDodClassName(rankMarketDod))}>
                          {rankMarketDod > 0 && <span>+</span>}
                          {rankMarketDod}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="dbi-update-rank-tips">统计当日上榜前十的国家数量及相对前一天的变化数</div>
      </div>
    </div>
  );
};

export default ProductChangedRankStore;
